import { Link } from "react-router-dom";
import styles from "./Product.module.css";

const Product = ({ product }) => {
  return (
    <div className={styles.productWrapper}>
      <div className={styles.productImage}>
        <img
          src={
            Array.isArray(product.attachment_files) &&
            product.attachment_files.length > 0
              ? product.attachment_files[0].server_relative_url.length > 100
                ? product.attachment_files[0].server_relative_url
                : "/assets/image/logo.png"
              : "/assets/image/logo.png"
          }
          alt={product.title}
        />
      </div>
      <div className={styles.contentWrapper}>
        <p className={styles.productContent}>
          {product.title ? product.title : "بدون عنوان"}
        </p>
        <p className={styles.productContentDescription}>
          {product.short_description}
        </p>
        <Link
          to={product.destination_url || "/"}
          target={
            typeof product.destination_url === "string" &&
            product.destination_url.length > 0
              ? product.destination_url.startsWith("http")
                ? "_blank"
                : null
              : null
          }
        >
          مشاهده
        </Link>
      </div>
    </div>
  );
};

export default Product;
